// Simple client-side API using localStorage for demo and offline use
// Keys
const STORAGE_KEY = 'aed_list_v1';

function readAll() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (e) {
    console.error('Failed to read AEDs from storage', e);
    return [];
  }
}

function writeAll(items) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  } catch (e) {
    console.error('Failed to write AEDs to storage', e);
  }
}

export async function fetchAEDs() {
  // Simulate async
  return Promise.resolve(readAll());
}

export async function addAED(aed) {
  const items = readAll();
  const id = aed.id ?? (Date.now() + Math.random()).toString(36);
  const toSave = {
    id,
    name: aed.name || 'Unnamed',
    address: aed.address || '',
    latitude: typeof aed.latitude === 'number' ? aed.latitude : parseFloat(aed.latitude || '0'),
    longitude: typeof aed.longitude === 'number' ? aed.longitude : parseFloat(aed.longitude || '0'),
    description: aed.description || '',
    accessibility: aed.accessibility || '',
    created_at: aed.created_at || new Date().toISOString(),
    updated_at: aed.updated_at || new Date().toISOString(),
  };
  items.push(toSave);
  writeAll(items);
  return Promise.resolve(toSave);
}
